/*! Image Map Resizer (imageMapResizer.min.js ) - v1.0.10 - 2019-04-10
 *  Desc: Resize HTML imageMap to scaled image.
 *  Copyright: (c) 2019 David J. Bradshaw - dave@bradshaw.net
 *  License: MIT
 */

!function(){"use strict";function r(){function e(){var r={width:u.width/u.naturalWidth,height:u.height/u.naturalHeight},a={width:parseInt(window.getComputedStyle(u,null).getPropertyValue("padding-left"),10),height:parseInt(window.getComputedStyle(u,null).getPropertyValue("padding-top"),10)};i.forEach(function(e,t){var n=0;o[t].coords=e.split(",").map(function(e){var t=1==(n=1-n)?"width":"height";return a[t]+Math.floor(Number(e)*r[t])}).join(",")})}function t(e){return e.coords.replace(/ *, */g,",").replace(/ +/g,",")}function n(){clearTimeout(d),d=setTimeout(e,250)}function r(e){return document.querySelector('img[usemap="'+e+'"]')}var a=this,o=null,i=null,u=null,d=null;"function"!=typeof a._resize?(o=a.getElementsByTagName("area"),i=Array.prototype.map.call(o,t),u=r("#"+a.name)||r(a.name),a._resize=e,u.addEventListener("load",e,!1),window.addEventListener("focus",e,!1),window.addEventListener("resize",n,!1),window.addEventListener("readystatechange",e,!1),document.addEventListener("fullscreenchange",e,!1),u.width===u.naturalWidth&&u.height===u.naturalHeight||e()):a._resize()}function e(){function t(e){e&&(!function(e){if(!e.tagName)throw new TypeError("Object is not a valid DOM element");if("MAP"!==e.tagName.toUpperCase())throw new TypeError("Expected <MAP> tag, found <"+e.tagName+">.")}(e),r.call(e),n.push(e))}var n;return function(e){switch(n=[],typeof e){case"undefined":case"string":Array.prototype.forEach.call(document.querySelectorAll(e||"map"),t);break;case"object":t(e);break;default:throw new TypeError("Unexpected data type ("+typeof e+").")}return n}}"function"==typeof define&&define.amd?define([],e):"object"==typeof module&&"object"==typeof module.exports?module.exports=e():window.imageMapResize=e(),"jQuery"in window&&(window.jQuery.fn.imageMapResize=function(){return this.filter("map").each(r).end()})}();
//# sourceMappingURL=imageMapResizer.map



/*!
 * hoverIntent v1.10.2 // 2020.04.28 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2019 Brian Cherne
 */
!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):"object"==typeof module&&module.exports?module.exports=factory(require("jquery")):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";function track(ev){cX=ev.pageX,cY=ev.pageY}function isFunction(value){return"function"==typeof value}var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});function handleHover(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){!function(ev,$el,s,out){var data=$el.data("hoverIntent");data&&delete data[s.id],out.apply($el[0],[ev])}(ev,$el,state,cfg.out)},cfg.timeout)}}return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});



// Add your custom JS here.

AOS.init();



jQuery(document).ready(function($){
	
	$(window).unbind('resize');
	
	// Benefits Toggle on Click
	
	$('.wp-custom-benefits.detailed .toggle-on-click .icon-left, .wp-custom-benefits.detailed .toggle-on-click h3').click(function(){
		var container = $(this).closest('.toggle-on-click');
		
		if( container.hasClass('expanded') ){
			// Collapse
			$(this).closest('.toggle-on-click').removeClass('expanded');
		} else {
			// Expand
			$(this).closest('.toggle-on-click').addClass('expanded');
		}
		
	});
	
	
	
	// How it works - Image Map
	
	$('map.image-map').imageMapResize();
	
	$('map.image-map area, .how-it-works-imagemap .box-title')
		.mouseenter(function(e){
			
			var container = $(this).closest('.how-it-works-imagemap');
			
			// Show
			container.find('.box.' + $(this).attr('data-box')).addClass('visible');
			
		})
		.mouseleave(function(e){
			
			var container = $(this).closest('.how-it-works-imagemap');
			
			// Hide
			container.find('.box').removeClass('visible');
			
		})
	;
	
	
	// Card Issuing - Image Map
	
	$('map[name=card-image-map]').imageMapResize();
	
	$('map[name=card-image-map] area, .card-issuing-imagemap .box-title')
		.mouseenter(function(e){
			
			var container = $(this).closest('.card-issuing-imagemap');
			
			// Show
			container.find('.' + $(this).attr('data-box')).addClass('visible');
			
		})
		.mouseleave(function(e){
			
			var container = $(this).closest('.card-issuing-imagemap');
			
			// Hide
			container.find('.box').removeClass('visible');
			
		})
	;
	
	
	// Bin sponsorship table and Reconciliation
	$('.bin-sponsorship-table .header, .reconciliation-table .header').click(function(){
		var accordion = $( $(this).attr('data-target') );
		var parentTable = $(this).closest('.bin-sponsorship-table, .reconciliation-table');
	
		if( accordion.css('display') == 'none' ){
			// Close all other accordions in the same parent table (desktop only)
			if ($(window).width() > 768) {
				parentTable.find('.header.expanded').not(this).each(function(){
					$(this).removeClass('expanded');
					$( $(this).attr('data-target') ).fadeOut();
				});
			}
			
			// Open this accordion
			$(this).addClass('expanded');
			accordion.fadeIn();
		} else {
			$(this).removeClass('expanded');
			accordion.fadeOut();
		}
	});
	
	
	
	// Business as a Service
	$('.baas-diagram .header').click(function(){
		
		var accordion = $( $(this).attr('data-target') );
	
		if( accordion.css('display') == 'none' ){
			$(this).addClass('expanded');
			accordion.slideDown();
		} else {
			$(this).removeClass('expanded');
			accordion.slideUp();
		}
	});
	
	
	// Mega Nav
	$('#mega-nav-target-solutions .header').click(function(){
		
		var accordion = $( $(this).attr('data-target') );
	
		if( accordion.css('display') == 'none' ){
			$(this).addClass('expanded');
			accordion.slideDown();
		} else {
			$(this).removeClass('expanded');
			accordion.slideUp();
		}
	});
	
	
	// BaaS Infographic v2
	$('.baas-infographic-v2 .btn.title').click(function(){
		var block = $(this).closest('.custom-block');
		block.find('.box.expanded').removeClass('expanded');
		
		var thisBox = $(this).attr('data-id');
		block.find('.box.' + thisBox).addClass('expanded');
		
		if( $(this).attr('data-scroll') == 'true' ){
			const element = document.getElementById( thisBox );
			element.scrollIntoView(false);
		}
	});
	
	
	// Manage Funds Infographic
	$('.apfx-manage-funds .btn.title').hover(
		// In
		function(){
			var block = $(this).closest('.custom-block');
			block.find('.expanded').removeClass('expanded');
			
			var thisBox = $(this).attr('data-id');
			block.find('.' + thisBox).addClass('expanded');
		},
		// Out
		function(){
			var block = $(this).closest('.custom-block');
			block.find('.expanded').removeClass('expanded');
		}
	);
	
	
	// Platform Features
	
	$('.platform-features .header').click(function(){
		var tab = $(this).closest('.tab-pane');
		var accordion = $( $(this).attr('data-target') );
	
		// if( accordion.css('display') == 'none' ){
		// 	$(this).addClass('expanded');
		// } else {
		// 	$(this).removeClass('expanded');
		// }
		
		// // Close all others
		// tab.find('.accordion').each(function(){
		// 	var thisAccordion = $(this);
		// 	if( thisAccordion != accordion ){
		// 		thisAccordion.
		// 	}
		// };
	});


	$('.platform-features .btn-link').click(function(e){
		// On mobile, prevent Bootstrap's default accordion behavior to allow multiple open
		if ($(window).width() <= 768) {
			e.stopPropagation();
			
			var target = $($(this).attr('data-target') || $(this).attr('href'));
			var isExpanded = $(this).attr('aria-expanded') === 'true';
			
			if (isExpanded) {
				// Collapse this one
				target.removeClass('show');
				$(this).attr('aria-expanded', 'false').addClass('collapsed');
			} else {
				// Expand this one
				target.addClass('show');
				$(this).attr('aria-expanded', 'true').removeClass('collapsed');
			}
		}
		// On desktop, let Bootstrap handle normal accordion behavior
	});
	
	if( $('.platform-features').length > 0 ){
		
		// Init
		selectPFTab(window.location.hash);
		
		// Change Url
		$('.platform-features .nav-link').click(function(e){
			var navLink = $(this);
			var tab = $(this).attr('aria-controls');
			
			// If the tab is already active, collapse it
			if (navLink.hasClass('active')) {
				e.preventDefault();
				e.stopPropagation();
				
				// Use Bootstrap's tab method to hide
				navLink.tab('dispose');
				navLink.removeClass('active');
				$('#' + tab).removeClass('active show');
				//window.location.hash = '';


			} else {
				// Let Bootstrap handle the normal tab activation
				//window.location.hash = '#' + tab;
			}

		});

		
		// Change from dropdown
		$('#mega-nav-target-products a[data-tab-target]').click(function(e){
			e.preventDefault();
			selectPFTab('#' + $(this).attr('data-tab-target'));
			//window.location.hash = '#' + $(this).attr('data-tab-target');
		});
		
	}
	
		function selectPFTab(tabHash){
			
			// Has Hash?
			if( tabHash != '' ){
				var tabContent = $(tabHash);
			} else {
				var tabContent = $('#nav-1');
			}
			
			if (tabHash != '') {
				// Remove other tabs
				var tabs = $('.platform-features .nav-tabs .nav-link');
				var tabContents = $('.platform-features .tab-content .tab-pane');
				
				tabContents.removeClass('active show');
				tabs.removeClass('active');
				
				var tab = $( '#' + tabContent.attr('aria-labelledby') );
				tabContent.addClass('active show');
				tab.addClass('active');
			}
			
		}



	
	
	// GTanslate
	
	$('.translator .close').click(function(){
		$(this).closest('.translator').remove();
	});
	
	
	
	$('.mega-nav-link').hoverIntent(
		// In
		function(e){
			var target = megaNavTarget($(this));
			$('#' + target).addClass('expanded');
		},
		
		// Out
		function(e){
			var target = megaNavTarget($(this));
			$('#' + target).removeClass('expanded');
		}
	);
	
	function megaNavTarget(thisElement){
		var classes = thisElement.attr('class').split(/\s+/);
		const target = classes.find(element => {
			return element.startsWith('mega-nav-target-');
		});
		return target;
	}
	
	// Equalise Mega Nav Heights
	function equaliseMegaNavs(){
			
		var megaNavSize = 0;
		
		// Get heights
		$('.mega-nav').each(function(){
			var thisHeight = $(this).outerHeight();
			if( thisHeight > megaNavSize ){
				megaNavSize = thisHeight;
			}
		});
		
		// Apply Heights
		$('.mega-nav').css('min-height', megaNavSize + 'px');
		
	}
	
	equaliseMegaNavs();
	
	
	// Guides
	$('.jotform-popup').click(function(){
		$('#jotform-modal-guides').modal('show');
		
		// Update iFrame
		document.getElementById('jotform-guide-iframe').src = $(this).attr('data-form');
	});
	
	
	// Infographic 
	
		// Sections
		$('.infographic-desktop .tab').click(function(){
			var section = $(this).attr('data-section');
			var infographic = $(this).closest('.infographic-desktop');
			infographic.attr('data-selected-section', section);
		});
		
		// Links
		$('.infographic-desktop .info-link').hover(
			// In
			function(){
				var link = $(this).attr('data-link');
				var infographic = $(this).closest('.infographic-desktop');
				infographic.attr('data-selected-link', link);
			},
			
			// Out
			function(){
				var infographic = $(this).closest('.infographic-desktop');
				infographic.attr('data-selected-link', '');
			}
		);
		
		
	// Use Cases
	
		var device_type;
		if( $(window).width() < 976 ){
			device_type = 'mobile';
		} else {
			device_type = 'desktop';
		}
		
		// Init
		$('.wp-use-cases').each(function(){
			
			// Auto expand only for desktop
			if( device_type == 'desktop' ){
				
				var firstLink = $(this).find('aside .content-nav').first().find('a.toggle');
				toggleUseCase(firstLink, true);
			}
			
		});
		
		//Toggle
		$('.wp-use-cases .toggle').click(function(e){
			e.preventDefault();
			e.stopPropagation();
			toggleUseCase($(this), false);
		});
		
			function toggleUseCase(thisLink, firstClick){
				
				var useCase = thisLink.closest('.wp-use-cases');	
				var target = $( useCase.find('.use-cases ' + thisLink.attr('href')) );
				var targetLinks = useCase.find('a.toggle[href=' + thisLink.attr('href') + ']' );
				
				switch( device_type ){
				case 'desktop':
				
					// Expand
					if( !thisLink.hasClass('active') ){
						
						// Hide current selected (if not this)
						var currentLink = useCase.find('.toggle.active');
						
						// Not already selected
						if( currentLink.length > 0 ){
							
							currentLink.removeClass('active');
							targetLinks.addClass('active');
							
							useCase.find(currentLink.attr('href')).removeClass('displayed').fadeOut(function(){
								target.fadeIn()
								target.addClass('displayed');
							});
							
						// First click
						} else {
							
							targetLinks.addClass('active');
							target.fadeIn();
							target.addClass('displayed');
							
						}
						
					}
					
					break;
					
				case 'mobile':
					console.log('mobile');
					
					if( targetLinks.hasClass('active') ){
						target.slideUp();	
						targetLinks.removeClass('active');
					} else {
						
						// Remove any active links
						useCase.find('a.toggle.active').each(function(){
							useCase.find($(this).attr('href')).slideUp().removeClass('active');
						});
						
						// Expand current link
						target.slideDown();
						targetLinks.addClass('active');
					}
					
					break;
					
				}
			}
			
	// BaaS LP (Infographic)
	$('.baas-lp .layer').hover(
		// In
		function(){
			$(this).closest('.baas-lp').attr('data-hover', $(this).attr('data-id'));
		},
		// Out
		function(){
			$(this).closest('.baas-lp').attr('data-hover','');
		}
	);
			
			
	// Timeline Owl Carousel
	$('.owl-carousel').owlCarousel({
		margin: 0,
		nav: true,
		navText: ['<?xml version="1.0" encoding="UTF-8"?><svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>timeline-left</title><g id="About-Us" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Timeline-arrows" transform="translate(-0, 0)" fill="#2DAFD7" fill-rule="nonzero"><g id="timeline-left"><path d="M15.7,0 C7,0 0,7 0,15.7 C0,24.4 7,31.4 15.7,31.4 C24.4,31.4 31.4,24.4 31.4,15.7 C31.4,7 24.4,0 15.7,0 Z M15.7,27.4 C9.3,27.4 4,22.2 4,15.7 C4,9.2 9.2,4 15.7,4 C22.2,4 27.4,9.2 27.4,15.7 C27.4,22.2 22.2,27.4 15.7,27.4 Z" id="Shape"></path><path d="M21.5,13.9 L15.1,13.9 L15.1,8.6 L7.8,15.9 L15.1,23.2 L15.1,17.9 L21.5,17.9 C22.6,17.9 23.5,17 23.5,15.9 C23.5,14.8 22.6,13.9 21.5,13.9 Z" id="Path"></path></g></g></g></svg>', '<?xml version="1.0" encoding="UTF-8"?><svg width="33px" height="32px" viewBox="0 0 33 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>timeline-right</title><g id="About-Us" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Timeline-arrows" transform="translate(-73, 0)" fill="#2DAFD7" fill-rule="nonzero"><g id="timeline-right" transform="translate(73.8, 0)"><path d="M15.7,0 C7,0 -1.42108547e-14,7 -1.42108547e-14,15.7 C-1.42108547e-14,24.4 7,31.4 15.7,31.4 C24.4,31.4 31.4,24.4 31.4,15.7 C31.4,7 24.4,0 15.7,0 Z M15.7,27.4 C9.3,27.4 4,22.2 4,15.7 C4,9.2 9.2,4 15.7,4 C22.1,4 27.4,9.2 27.4,15.7 C27.4,22.2 22.1,27.4 15.7,27.4 Z" id="Shape"></path><path d="M16.3,13.9 L9.9,13.9 C8.8,13.9 7.9,14.8 7.9,15.9 C7.9,17 8.8,17.9 9.9,17.9 L16.3,17.9 L16.3,23.2 L23.6,15.9 L16.3,8.6 L16.3,13.9 Z" id="Path"></path></g></g></g></svg>'],
		dots: true,
		responsive:{
			0:{
				items:1
			},
			768:{
				items:2
			}
		}
	});
	
	
	// GEO IP
	// ------
	
	var check_location =  $('body[data-check-visitor]').length > 0;
	
	if( check_location ){
		
		var cookie_name = 'geo_ip_preference';
		
		// Has cookie preference been set?
		if( !readCookie(cookie_name) ){
			
			console.log('Checking location - Prompt is needed');
			
			var is_us_page = ( $('body[data-is-us]').length > 0 ? true : false );
			
			geoip_detect.get_info().then(function(record) {
				
				if (record.error()) {
						console.error('WARNING Geodata Error:' + record.error() );
						
				} else {
					var country = record.get('country.iso_code');
					
					// Debug
					//country = 'GB';
					
					// Current page is US
					if( is_us_page ){
						
						// Visitor not us
						if( country != 'US' ){
							console.log('Display US Pop Up');
							
							$('#geo-ip-modal-us').modal('show');
							
							// Set cookie (after prompted)
							//createCookie(cookie_name, true, 30);
						}
						
					} else {
					// Current page is International
					
						// Visitor if from US
						if( country == 'US' ){
							console.log('Display International Pop Up');
							
							$('#geo-ip-modal-int').modal('show');
							
							// Set cookie (after prompted)
							//createCookie(cookie_name, true, 30);
						}
						
					}
					
				}
		
			});
			
		}
		
		
		// Modal Click Events
		
		// Iternational
		$('#geo-ip-modal-int .choice').click(function(){
			// Yes, redirect
			if( $(this).hasClass('approve') ){
				console.log('approved');
				createCookie(cookie_name, 1, 30);
				location.href = '/prepaid/us/';
			}
			//No, dismiss
			if( $(this).hasClass('decline') ){
				console.log('declined');
				createCookie(cookie_name, 0, 30);
			}
		});
		
		// US
		$('#geo-ip-modal-us .choice').click(function(){
			// Yes, redirect
			if( $(this).hasClass('approve') ){
				console.log('approved');
				createCookie(cookie_name, 1, 30);
				location.href = '/';
			}
			//No, dismiss
			if( $(this).hasClass('decline') ){
				console.log('declined');
				createCookie(cookie_name, 0, 30);
			}
		});
		
		function createCookie(name, value, days) {
			if (days) {
					var date = new Date();
					date.setTime(date.getTime()+(days*24*60*60*1000));
					date.setTime(date.getTime()+(days*24*60*60*1000));
					var expires = "; expires="+date.toGMTString();
			} else {
				var expires = "";	
			}
			document.cookie = name+"="+value+expires+"; path=/";
		}
		
		function readCookie(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for ( var i=0;i < ca.length;i++ ) {
					var c = ca[i];
					while (c.charAt(0)==' ') c = c.substring(1,c.length);
					if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
		}
		
	}


	// Make .wp-content-nav sticky
	if( $('.wp-content-nav').length > 0 ){
		
		$('.wp-content-nav').each(function(){
			var $nav = $(this);
			var originalOffset = $nav.offset().top;
			var originalLeft = $nav.offset().left;
			var navWidth = $nav.outerWidth();
			var navHeight = $nav.outerHeight();
			var isSticky = false;
			
			// Get total sticky offset (admin bar + header)
			function getStickyOffset() {
				var offset = 0;
				
				// WordPress admin bar
				var $adminBar = $('#wpadminbar');
				if ($adminBar.length && $adminBar.is(':visible')) {
					offset += $adminBar.outerHeight();
				}
				
				// Site header
				var $header = $('#site-header');
				if ($header.length) {
					offset += $header.outerHeight();
				}
				
				return offset;
			}
			
			// Create placeholder to maintain layout
			var $placeholder = $('<div class="wp-content-nav-placeholder"></div>').css({
				height: navHeight + 'px',
				display: 'none'
			});
			$nav.after($placeholder);
			
			$(window).on('scroll', function(){
				var scrollTop = $(window).scrollTop();
				var stickyOffset = getStickyOffset();
				var triggerPoint = originalOffset - stickyOffset;
				
				if (scrollTop >= triggerPoint && !isSticky) {
					// Make sticky
					var stickyStyles = {
						position: 'fixed',
						top: stickyOffset + 'px',
						zIndex: '4',
						margin: '0'
					};
					
					// Full width for viewports less than 500px
					if ($(window).width() < 500) {
						stickyStyles.left = '0';
						stickyStyles.right = '0';
						stickyStyles.width = '100%';
					} else {
						stickyStyles.left = originalLeft + 'px';
						stickyStyles.width = navWidth + 'px';
					}
					
					$nav.css(stickyStyles);
					$nav.addClass('sticking');
					$placeholder.show();
					isSticky = true;
					
				} else if (scrollTop < triggerPoint && isSticky) {
					// Remove sticky
					$nav.css({
						position: '',
						top: '',
						left: '',
						right: '',
						width: '',
						zIndex: '',
						margin: ''
					});
					$nav.removeClass('sticking');
					$placeholder.hide();
					isSticky = false;
				}
			});
			
			// Handle window resize
			$(window).on('resize', function(){
				if (!isSticky) {
					originalOffset = $nav.offset().top;
					originalLeft = $nav.offset().left;
					navWidth = $nav.outerWidth();
				}
				var newHeight = $nav.outerHeight();
				$placeholder.css('height', newHeight + 'px');
				
				// Update sticky position if currently sticky
				if (isSticky) {
					var stickyOffset = getStickyOffset();
					var resizeStyles = {
						'top': stickyOffset + 'px'
					};
					
					// Full width for viewports less than 500px
					if ($(window).width() < 500) {
						resizeStyles.left = '0';
						resizeStyles.right = '0';
						resizeStyles.width = '100%';
					} else {
						resizeStyles.left = originalLeft + 'px';
						resizeStyles.width = navWidth + 'px';
						resizeStyles.right = '';
					}
					
					$nav.css(resizeStyles);
				}
			});
		});
		
	}
	
	// Smooth scroll with offset for anchor links
	// Content Nav Only
	$('.wp-content-nav a[href^="#"]').on('click', function(e) {
		var target = $(this.getAttribute('href'));
		
		if (target.length) {
			e.preventDefault();
			
			// Calculate total sticky offset (same function as sticky nav)
			var offset = 0;
			
			// WordPress admin bar
			var $adminBar = $('#wpadminbar');
			if ($adminBar.length && $adminBar.is(':visible')) {
				offset += $adminBar.outerHeight();
			}
			
			// Site header
			var $header = $('#site-header');
			if ($header.length) {
				offset += $header.outerHeight();
			}
			
			// Content nav if sticky
			var $contentNav = $('.wp-content-nav.sticking');
			if ($contentNav.length) {
				offset += $contentNav.outerHeight();
			}
			
			// Add extra padding
			offset += 80;
			
			// Jump directly to target
			$('html, body').scrollTop(target.offset().top - offset);
		}
	});


	// If hash on the url, then scroll with an offset
	if( window.location.hash ){
		// Add a small delay to ensure all elements are rendered
		setTimeout(function() {
			var target = $(window.location.hash);
			
			if (target.length) {
				
				// Calculate total sticky offset (same function as sticky nav)
				var offset = 0;
				
				// WordPress admin bar
				var $adminBar = $('#wpadminbar');
				if ($adminBar.length && $adminBar.is(':visible')) {
					offset += $adminBar.outerHeight();
				}
				
				// Site header
				var $header = $('#site-header');
				if ($header.length) {
					offset += $header.outerHeight();
				}
				
				// Content nav if sticky
				var $contentNav = $('.wp-content-nav.sticking');
				if ($contentNav.length) {
					offset += $contentNav.outerHeight();
				}
				
				// Add extra padding
				offset += 120;
				
				// Jump directly to target
				$('html, body').scrollTop(target.offset().top - offset);
			}
		}, 100); // 100ms delay
	}	
	
	
}); // End document.ready